"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Constants = require("../00_environment/Constants");

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockWithLeftHeader = function BlockWithLeftHeader(_ref) {
  var ribbonContent = _ref.ribbonContent,
      headerContent = _ref.headerContent,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$noContentPadding = _ref.noContentPadding,
      noContentPadding = _ref$noContentPadding === void 0 ? false : _ref$noContentPadding,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      backgroundColor: 'white'
    }, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withTopBarFont)({
      flexGrow: '1',
      flexShrink: '0',
      padding: '24px 0px',
      paddingBottom: 0,
      backgroundColor: _Colors.topBarBgColor,
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      maxWidth: '100vw'
    })
  }, ribbonContent && /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withBlockHeaderRibbonFont)({
      textAlign: 'center',
      marginTop: -4,
      marginBottom: 4
    })
  }, ribbonContent), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%'
    }
  }, headerContent)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexGrow: '2',
      flexDirection: 'column',
      padding: noContentPadding ? 0 : 24,
      paddingTop: 24,
      paddingBottom: 24,
      border: "solid 1px ".concat(_Colors.widgetBorderColor),
      borderRadius: "0 ".concat(_Constants.roundedElementBorderRadius, " ").concat(_Constants.roundedElementBorderRadius, " 0"),
      maxWidth: '100vw'
    }
  }, children));
};

var _default = BlockWithLeftHeader;
exports["default"] = _default;